export const SET_DOWNLOAD_REPORT_DISABLE = 'SET_DOWNLOAD_REPORT_DISABLE';
export const CLEAR_DOWNLOAD_REPORT_DISABLE = 'SET_DOWNLOAD_REPORT_DISABLE';
export const SET_SUCCESS_OPERATION_MESSAGE = 'SET_SUCCESS_OPERATION_MESSAGE';
export const CLEAR_SUCCESS_OPERATION_MESSAGE = 'CLEAR_SUCCESS_OPERATION_MESSAGE';
export const SET_TOP_LEVEL_DOMAIN_LIST_OPTIONS = 'SET_TOP_LEVEL_DOMAIN_LIST_OPTIONS';
export const CLEAR_TOP_LEVEL_DOMAIN_LIST_OPTIONS = 'CLEAR_TOP_LEVEL_DOMAIN_LIST_OPTIONS';
export const SET_TOP_LEVEL_DOMAINS = 'SET_TOP_LEVEL_DOMAINS';
export const CLEAR_TOP_LEVEL_DOMAINS = 'CLEAR_TOP_LEVEL_DOMAINS';
export const SET_TOP_LEVEL_DOMAINS_ASSETS = 'SET_TOP_LEVEL_DOMAINS_ASSETS';
export const CLEAR_TOP_LEVEL_DOMAINS_ASSETS = 'CLEAR_TOP_LEVEL_DOMAINS_ASSETS';
export const SET_TOP_LEVEL_DOMAINS_OPTIONS = 'SET_TOP_LEVEL_DOMAINS_OPTIONS';
export const CLEAR_TOP_LEVEL_DOMAINS_OPTIONS = 'CLEAR_TOP_LEVEL_DOMAINS_OPTIONS';
export const SET_INFRASTRUCTURE_LIST_OPTIONS = 'SET_INFRASTRUCTURE_LIST_OPTIONS';
export const CLEAR_INFRASTRUCTURE_LIST_OPTIONS = 'CLEAR_INFRASTRUCTURE_LIST_OPTIONS';
export const SET_INFRASTRUCTURE = 'SET_INFRASTRUCTURE';
export const CLEAR_INFRASTRUCTURE = 'CLEAR_INFRASTRUCTURE';
export const SET_PORT_OPTIONS = 'SET_PORT_OPTIONS';
export const CLEAR_PORT_OPTIONS = 'CLEAR_PORT_OPTIONS';
export const SET_WAF_OPTIONS = 'SET_WAF_OPTIONS';
export const CLEAR_WAF_OPTIONS = 'CLEAR_WAF_OPTIONS';
export const SET_SERVICES_OPTIONS = 'SET_SERVICES_OPTIONS';
export const CLEAR_SERVICES_OPTIONS = 'CLEAR_SERVICES_OPTIONS';
export const SET_LOCATION_OPTIONS = 'SET_LOCATION_OPTIONS';
export const CLEAR_LOCATION_OPTIONS = 'CLEAR_LOCATION_OPTIONS';
export const SET_COORDINATES_OPTIONS = 'SET_COORDINATES_OPTIONS';
export const CLEAR_COORDINATES_OPTIONS = 'CLEAR_COORDINATES_OPTIONS';
export const SET_SUBDOMAIN_TAGS_SUGGESTIONS = 'SET_SUBDOMAIN_TAGS_SUGGESTIONS';
export const CLEAR_SUBDOMAIN_TAGS_SUGGESTIONS = 'CLEAR_SUBDOMAIN_TAGS_SUGGESTIONS';
export const SET_DOMAIN_TAGS_SUGGESTIONS = 'SET_DOMAIN_TAGS_SUGGESTIONS';
export const CLEAR_DOMAIN_TAGS_SUGGESTIONS = 'CLEAR_DOMAIN_TAGS_SUGGESTIONS';
export const SET_LEAKS_LIST_OPTIONS = 'SET_LEAKS_LIST_OPTIONS';
export const CLEAR_LEAKS_LIST_OPTIONS = 'CLEAR_LEAKS_LIST_OPTIONS';
export const SET_LEAKS = 'SET_LEAKS';
export const CLEAR_LEAKS = 'CLEAR_LEAKS';
export const SET_TLDS_WITH_NO_LEAKS_SCAN = 'SET_TLDS_WITH_NO_LEAKS_SCAN';
export const CLEAR_TLDS_WITH_NO_LEAKS_SCAN = 'CLEAR_TLDS_WITH_NO_LEAKS_SCAN';
export const SET_TLDS_WITH_LEAKS_SCAN = 'SET_TLDS_WITH_LEAKS_SCAN';
export const CLEAR_TLDS_WITH_LEAKS_SCAN = 'CLEAR_TLDS_WITH_LEAKS_SCAN';
export const SET_LEAKS_SOURCE_OPTIONS = 'SET_LEAKS_SOURCE_OPTIONS';
export const CLEAR_LEAKS_SOURCE_OPTIONS = 'CLEAR_LEAKS_SOURCE_OPTIONS';
export const SET_LEAKS_TYPE_OPTIONS = 'SET_LEAKS_TYPE_OPTIONS';
export const CLEAR_LEAKS_TYPE_OPTIONS = 'CLEAR_LEAKS_TYPE_OPTIONS';
export const SET_EMPLOYEES_LIST_OPTIONS = 'SET_EMPLOYEES_LIST_OPTIONS';
export const CLEAR_EMPLOYEES_LIST_OPTIONS = 'CLEAR_EMPLOYEES_LIST_OPTIONS';
export const SET_EMPLOYEES = 'SET_EMPLOYEES';
export const CLEAR_EMPLOYEES = 'CLEAR_EMPLOYEES';
export const SET_TLDS_WITH_NO_EMPLOYEES_SCAN = 'SET_TLDS_WITH_NO_EMPLOYEES_SCAN';
export const CLEAR_TLDS_WITH_NO_EMPLOYEES_SCAN = 'CLEAR_TLDS_WITH_NO_EMPLOYEES_SCAN';
export const SET_TLDS_WITH_EMPLOYEES_SCAN = 'SET_TLDS_WITH_EMPLOYEES_SCAN';
export const CLEAR_TLDS_WITH_EMPLOYEES_SCAN = 'CLEAR_TLDS_WITH_EMPLOYEES_SCAN';
export const SET_TECHNOLOGIES_LIST_OPTIONS = 'SET_TECHNOLOGIES_LIST_OPTIONS';
export const CLEAR_TECHNOLOGIES_LIST_OPTIONS = 'CLEAR_TECHNOLOGIES_LIST_OPTIONS';
export const SET_TECHNOLOGIES = 'SET_TECHNOLOGIES';
export const CLEAR_TECHNOLOGIES = 'CLEAR_TECHNOLOGIES';
export const SET_PASSWORD_SPRAY_STATS_UPDATED = 'SET_PASSWORD_SPRAY_STATS_UPDATED';
export const CLEAR_PASSWORD_SPRAY_STATS_UPDATED = 'CLEAR_PASSWORD_SPRAY_STATS_UPDATED';
export const SET_CLOUD_INSTANCES_LIST_OPTIONS = 'SET_CLOUD_INSTANCES_LIST_OPTIONS';
export const CLEAR_CLOUD_INSTANCES_LIST_OPTIONS = 'CLEAR_CLOUD_INSTANCES_LIST_OPTIONS';
export const SET_CLOUD_INSTANCES = 'SET_CLOUD_INSTANCES';
export const CLEAR_CLOUD_INSTANCES = 'CLEAR_CLOUD_INSTANCES';
export const SET_CLOUD_INSTANCES_FULL_ITEMS = 'SET_CLOUD_INSTANCES_FULL_ITEMS';
export const CLEAR_CLOUD_INSTANCES_FULL_ITEMS = 'CLEAR_CLOUD_INSTANCES_FULL_ITEMS';
export const SET_CLOUD_BUCKETS_LIST_OPTIONS = 'SET_CLOUD_BUCKETS_LIST_OPTIONS';
export const CLEAR_CLOUD_BUCKETS_LIST_OPTIONS = 'CLEAR_CLOUD_BUCKETS_LIST_OPTIONS';
export const SET_CLOUD_BUCKETS = 'SET_CLOUD_BUCKETS';
export const CLEAR_CLOUD_BUCKETS = 'CLEAR_CLOUD_BUCKETS';
export const SET_CLOUD_BUCKETS_FULL_ITEMS = 'SET_CLOUD_BUCKETS_FULL_ITEMS';
export const CLEAR_CLOUD_BUCKETS_FULL_ITEMS = 'CLEAR_CLOUD_BUCKETS_FULL_ITEMS';
export const SET_LOADING_PASSWORD_SPRAY = 'SET_LOADING_PASSWORD_SPRAY';
export const SET_PASSWORD_SPRAY_NOT_VALIDATE_DOMAINS = 'SET_PASSWORD_SPRAY_NOT_VALIDATE_DOMAINS';
export const CLEAR_PASSWORD_SPRAY_NOT_VALIDATE_DOMAINS = 'CLEAR_PASSWORD_SPRAY_NOT_VALIDATE_DOMAINS';
export const SET_PASSWORD_SPRAY_DOMAINS_WITHOUT_LICENSE = 'SET_PASSWORD_SPRAY_DOMAINS_WITHOUT_LICENSE';
export const CLEAR_PASSWORD_SPRAY_DOMAINS_WITHOUT_LICENSE = 'CLEAR_PASSWORD_SPRAY_DOMAINS_WITHOUT_LICENSE';
export const SET_TOP_LEVEL_DOMAINS_LOADING = 'SET_TOP_LEVEL_DOMAINS_LOADING';
export const SET_INFRASTRUCTURE_LOADING = 'SET_INFRASTRUCTURE_LOADING';
export const SET_EMPLOYEES_LOADING = 'SET_EMPLOYEES_LOADING';
export const SET_TECHNOLOGIES_LOADING = 'SET_TECHNOLOGIES_LOADING';
export const SET_LEAKS_LOADING = 'SET_LEAKS_LOADING';
export const SET_CLOUD_INSTANCES_LOADING = 'SET_CLOUD_INSTANCES_LOADING';
export const SET_CLOUD_BUCKETS_LOADING = 'SET_CLOUD_BUCKETS_LOADING';
export const SET_CLOUD_SERVICES_LOADING = 'SET_CLOUD_SERVICES_LOADING';
export const SET_CLOUD_ACCOUNTS_LOADING = 'SET_CLOUD_ACCOUNTS_LOADING';
export const SET_INFRASTRUCTURE_REF_ID = 'SET_INFRASTRUCTURE_REF_ID';
export const CLEAR_INFRASTRUCTURE_REF_ID = 'CLEAR_INFRASTRUCTURE_REF_ID';
export const SET_INFRASTRUCTURE_PROGRESS = 'SET_INFRASTRUCTURE_PROGRESS';
export const CLEAR_INFRASTRUCTURE_PROGRESS = 'CLEAR_INFRASTRUCTURE_PROGRESS';
export const SET_EMPLOYEES_REF_ID = 'SET_EMPLOYEES_REF_ID';
export const CLEAR_EMPLOYEES_REF_ID = 'CLEAR_EMPLOYEES_REF_ID';
export const SET_EMPLOYEES_PROGRESS = 'SET_EMPLOYEES_PROGRESS';
export const CLEAR_EMPLOYEES_PROGRESS = 'CLEAR_EMPLOYEES_PROGRESS';
export const SET_TECHNOLOGIES_REF_ID = 'SET_TECHNOLOGIES_REF_ID';
export const CLEAR_TECHNOLOGIES_REF_ID = 'CLEAR_TECHNOLOGIES_REF_ID';
export const SET_TECHNOLOGIES_PROGRESS = 'SET_TECHNOLOGIES_PROGRESS';
export const CLEAR_TECHNOLOGIES_PROGRESS = 'CLEAR_TECHNOLOGIES_PROGRESS';
export const SET_CLOUD_INSTANCES_REF_ID = 'SET_CLOUD_INSTANCES_REF_ID';
export const CLEAR_CLOUD_INSTANCES_REF_ID = 'CLEAR_CLOUD_INSTANCES_REF_ID';
export const SET_CLOUD_INSTANCES_PROGRESS = 'SET_CLOUD_INSTANCES_PROGRESS';
export const CLEAR_CLOUD_INSTANCES_PROGRESS = 'CLEAR_CLOUD_INSTANCES_PROGRESS';
export const SET_CLOUD_BUCKETS_REF_ID = 'SET_CLOUD_BUCKETS_REF_ID';
export const CLEAR_CLOUD_BUCKETS_REF_ID = 'CLEAR_CLOUD_BUCKETS_REF_ID';
export const SET_CLOUD_BUCKETS_PROGRESS = 'SET_CLOUD_BUCKETS_PROGRESS';
export const CLEAR_CLOUD_BUCKETS_PROGRESS = 'CLEAR_CLOUD_BUCKETS_PROGRESS';
export const SET_CLOUD_SERVICES_REF_ID = 'SET_CLOUD_SERVICES_REF_ID';
export const CLEAR_CLOUD_SERVICES_REF_ID = 'CLEAR_CLOUD_SERVICES_REF_ID';
export const SET_CLOUD_SERVICES_PROGRESS = 'SET_CLOUD_SERVICES_PROGRESS';
export const CLEAR_CLOUD_SERVICES_PROGRESS = 'CLEAR_CLOUD_SERVICES_PROGRESS';
export const SET_TOP_LEVEL_DOMAINS_REF_ID = 'SET_TOP_LEVEL_DOMAINS_REF_ID';
export const CLEAR_TOP_LEVEL_DOMAINS_REF_ID = 'CLEAR_TOP_LEVEL_DOMAINS_REF_ID';
export const SET_TOP_LEVEL_DOMAINS_PROGRESS = 'SET_TOP_LEVEL_DOMAINS_PROGRESS';
export const CLEAR_TOP_LEVEL_DOMAINS_PROGRESS = 'CLEAR_TOP_LEVEL_DOMAINS_PROGRESS';
export const SET_LEAKS_REF_ID = 'SET_LEAKS_REF_ID';
export const CLEAR_LEAKS_REF_ID = 'CLEAR_LEAKS_REF_ID';
export const SET_LEAKS_PROGRESS = 'SET_LEAKS_PROGRESS';
export const CLEAR_LEAKS_PROGRESS = 'CLEAR_LEAKS_PROGRESS';
export const SET_LEAKS_RUNNING_INTERVAL = 'SET_LEAKS_RUNNING_INTERVAL';
export const SET_INFRASTRUCTURE_RUNNING_INTERVAL = 'SET_INFRASTRUCTURE_RUNNING_INTERVAL';
export const SET_TLD_RUNNING_INTERVAL = 'SET_TLD_RUNNING_INTERVAL';
export const SET_CLOUD_INSTANCES_RUNNING_INTERVAL = 'SET_CLOUD_INSTANCES_RUNNING_INTERVAL';
export const SET_CLOUD_BUCKETS_RUNNING_INTERVAL = 'SET_CLOUD_BUCKETS_RUNNING_INTERVAL';
export const SET_CLOUD_SERVICES_RUNNING_INTERVAL = 'SET_CLOUD_SERVICES_RUNNING_INTERVAL';
export const SET_EMPLOYEES_RUNNING_INTERVAL = 'SET_EMPLOYEES_RUNNING_INTERVAL';
export const SET_TECHNOLOGIES_RUNNING_INTERVAL = 'SET_TECHNOLOGIES_RUNNING_INTERVAL';
export const SET_RETRY_COUNTER = 'SET_RETRY_COUNTER';
export const SET_INFOSTEALERS_LIST_OPTIONS = 'SET_INFOSTEALERS_LIST_OPTIONS';
export const CLEAR_INFOSTEALERS_ITEMS = 'CLEAR_INFOSTEALERS_ITEMS';
export const SET_INFOSTEALERS_LOADING = 'SET_INFOSTEALERS_LOADING';
export const SET_INFOSTEALERS_FILTERS = 'SET_INFOSTEALERS_FILTERS';
export const SET_INFOSTEALERS_PAGINATION_STATE = 'SET_INFOSTEALERS_PAGINATION_STATE';
export const SET_INFOSTEALERS_ITEMS = 'SET_INFOSTEALERS_ITEMS';
export const SET_INFOSTEALERS_REF_ID = 'SET_INFOSTEALERS_REF_ID';
export const CLEAR_INFOSTEALERS_REF_ID = 'CLEAR_INFOSTEALERS_REF_ID';
export const SET_INFOSTEALERS_PROGRESS = 'SET_INFOSTEALERS_PROGRESS';
export const CLEAR_INFOSTEALERS_PROGRESS = 'CLEAR_INFOSTEALERS_PROGRESS';
export const SET_INFOSTEALERS_PROGRESS_DATA = 'SET_INFOSTEALERS_PROGRESS_DATA';
export const SET_INFOSTEALERS_RUNNING_INTERVAL = 'SET_INFOSTEALERS_RUNNING_INTERVAL';
export const SET_INFOSTEALERS_POLLING_INTERVAL = 'SET_INFOSTEALERS_POLLING_INTERVAL';
export const SET_LAST_INFOSTEALERS_PROGRESS_CALL = 'SET_LAST_INFOSTEALERS_PROGRESS_CALL';
